import { RosterFiltersReducerState } from './types';
import { getDefaultFilters } from './helpers/helpers';

export const getDefaultState = (): RosterFiltersReducerState => ({
  isFilterByTypeOpened: false,
  filters: getDefaultFilters(),
  filtersForm: getDefaultFilters()
});
